/**
 * Where a verification link should land the user once the token is consumed.
 *
 * Better Auth redirects to this URL verbatim after verifying, so it has to be
 * absolute and on the web origin — a relative one resolves against the API
 * (api.fasterforward.se) and strands the user there.
 *
 * The landing route is deliberately outside `_public/_auth`: that layout
 * redirects signed-in users to "/", and `autoSignInAfterVerification` means the
 * user arrives already signed in — they would be bounced away before seeing any
 * confirmation.
 */
export const VERIFIED_ROUTE = "/e-post-verifierad";
export function verificationRedirectUrl(next) {
  const url = new URL(VERIFIED_ROUTE, window.location.origin);
  const target = next ?? `${window.location.pathname}${window.location.search}`;
  if (target && target !== VERIFIED_ROUTE) {
    url.searchParams.set("next", target);
  }
  return url.toString();
}